import { hasText } from 'shared/lib/common-util'
import { RuleResult } from '../../../../types/DeclarationP5'

const C0252Validator = {
  validateNameAndAddressRequirement: ({
    security,
    identificationNumber,
  } : {
    security: string
    identificationNumber?: string
  }): RuleResult => {
    if (['1', '3'].includes(security)) return 'REQUIRED'

    return hasText(identificationNumber) ? 'NOT_ALLOWED' : 'REQUIRED'
  },
}

export default C0252Validator
